import React from "react";
import styled from "styled-components";

const StyledIcon = styled.i`
  position: absolute;
  top: -10px;
  right: -5px;
  padding: 10px;
  cursor: pointer;
  font-size: 20px;
  color: #6a46e5;
  transition: transform 0.3s ease-out;
`;

interface LinkOpenIconProps {
  onClick: () => void;
}

const LinkOpenIcon = React.memo((props: LinkOpenIconProps) => (
  <StyledIcon
    className="la la-external-link"
    onClick={props.onClick}
    role="button"
    aria-label="Open link"
  />
));

export default LinkOpenIcon;
